import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import type { RootState } from '../store'
import { identifySegmentUser, initSegment, trackSegmentPage } from '../lib/segment'
import { clearAdAttributionCookie } from '../lib/attribution'

/** Sync Redux auth state and route changes to Segment. Renders nothing. */
export default function SegmentAuthBridge() {
  const user = useSelector((state: RootState) => state.auth.user)
  const location = useLocation()

  useEffect(() => {
    initSegment()
  }, [])

  useEffect(() => {
    identifySegmentUser(user)
    if (user) clearAdAttributionCookie()
  }, [user])

  useEffect(() => {
    trackSegmentPage(location.pathname + location.search)
  }, [location.pathname, location.search])

  return null
}
